import { PureComponent } from 'react';
import { Checkbox } from 'semantic-ui-react';

import withFormikInput from './withFormikInput';
import withFormField from './withFormField';

class _Checkbox extends PureComponent {
  onChange = (event, data) => {
    if (event.target) {
      // @ts-expect-error TS(2339): Property 'name' does not exist on type 'Readonly<{... Remove this comment to see the full error message
      event.target.name = this.props.name;
      // @ts-expect-error TS(2339): Property 'inverted' does not exist on type 'Readon... Remove this comment to see the full error message
      event.target.value = this.props.inverted ? !data.checked : data.checked;
    }
    // @ts-expect-error TS(2339): Property 'onChange' does not exist on type 'Readon... Remove this comment to see the full error message
    this.props.onChange(event);
  };

  render() {
    // @ts-expect-error TS(2339): Property 'onChange' does not exist on type 'Readon... Remove this comment to see the full error message
    const { onChange, inverted, value, ...rest } = this.props;

    const checked = inverted ? !value : value;

    return <Checkbox {...rest} checked={checked} onChange={this.onChange} />;
  }
}

const FormCheckbox = withFormikInput(withFormField(_Checkbox));
export default FormCheckbox;
